
import { useModifyApplicationConfiguration } from "../../configuration/ConfigurationContext";
import _pickBy from "lodash/pickBy";
import { IAppConfigurations } from "../../interfaces/IAppConfigurations";
import { ApplicationConfiguration } from "../../configuration/ApplicationConfiguration";
import { createLoaded } from "../../../../sg-core";

export type IUseApplyParameters = () => {
    apllyParameters: (parameters: IAppConfigurations) => void;
}

export const useApplyParameters: IUseApplyParameters = () => {
    const { setConfig } = useModifyApplicationConfiguration();

    const apllyParameters = (parameters: IAppConfigurations) => {

        let data: Partial<ApplicationConfiguration> = {
            activated: createLoaded(parameters.aktivoitu),

            companyName: parameters.yritys.nimi,
            companyAddress: parameters.yritys.katuosoite,


            emailSupport: parameters.sahkopostit.aktivoitu,
            smsSupport: parameters.tekstiviestit.aktivoitu,
            mapSupport: parameters.kartat.aktivoitu,

            showDeveloperSettings: parameters.kehitysvalikko,
            showRawApplicationErrors: parameters.virheviestit,
            testenviromentBackground: parameters.testi.taustakuva,

            archiveLimit: parameters.havainnot.arkistointi_suodatin ? " " : undefined,
            observationPublicByDefault: parameters.havainnot.oletukset.julkisuus,

            hideEmptyFieldsFromObservationDetails: parameters.esitys.kentat.tyhjat.piilotus,
            allowEditingObservation: parameters.havainnot.muokkaus.sallittu,

            allowChangingProcessingMarkingPublicity: parameters.kasittelymerkinnat.julkisuus.valittavissa,
            processingMarkingPublicityDefaultValue: parameters.kasittelymerkinnat.oletukset.julkisuus,

            showLanguageSelect: parameters.kielivalikko,
            languages: parameters.kielet,

            showUniqueObservationId: parameters.havainnot.nayta_yksiloiva_tunniste

            //  gateDirectUrl: parameters.gateDirectUrl,
            // showTenantSwitch: parameters.showTenantSwitch,
            //  applicationMenuHref: parameters.applicationMenuHref

        };

        const cleanData = _pickBy(data, v => v !== undefined)
        setConfig(cleanData);
    }

    return ({
        apllyParameters
    })

};
